import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  IS_UNIFIED_PORTAL,
  isSoftPortalEntryPath,
  isSoftPortalEntryPending,
  isSoftPortalSwitchActive,
  portalKindFromPath,
} from '../lib/portal';
import { portalSideAccess } from '../lib/portalAccess';

/**
 * Soft portal entry: never bounce back to /choose-portal while entering the
 * portal the user just picked (in-memory flag + matching path).
 */
export function RequirePortalChoice({ children }: { children: React.ReactNode }) {
  const { accessStatus, portalAccess } = useAuth();
  const location = useLocation();

  const onChooser = location.pathname === '/choose-portal';
  const pathKind = portalKindFromPath(location.pathname);
  const softEntry = Boolean(
    IS_UNIFIED_PORTAL &&
      (isSoftPortalEntryPending() ||
        isSoftPortalEntryPath(location.pathname) ||
        isSoftPortalSwitchActive(location.pathname)),
  );

  if (accessStatus === 'choose_portal' && !onChooser) {
    if (softEntry) return children;
    return <Navigate to="/choose-portal" replace />;
  }

  if (portalAccess && pathKind) {
    const side = portalSideAccess(portalAccess, pathKind);
    if (!side.hasAccess) {
      return <Navigate to="/choose-portal" replace />;
    }
  }

  return children;
}
